import Box from '@mui/material/Box'
import LeftMenu from './LeftMenu'
import Content from './Content'
import { useEffect, useState } from 'react'
import { useLocalStorage } from '../../hooks/useLocalStorage'
import { createTheme } from '@mui/material/styles'
import { ThemeProvider } from '@mui/material'
import { NotificationsCounterContextProvider } from '../../context/notificationsCounterContext/NotificationsCounterContextProvider'
import { useAuthContext } from '../../context/auth/AuthContextProvider'
import VersionChecker from '../../components/version/VersionChecker'
import SupportButton from '../../components/support/SupportButton'
import { SupportCounterContextProvider } from '../../context/supportCounterContext/SupportCounterContextProvider'

const theme = createTheme({
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          [`&.Mui-disabled:hover .MuiOutlinedInput-input`]: {
            cursor: 'not-allowed',
          },
          [`&.Mui-disabled .MuiOutlinedInput-input`]: {
            '-webkit-text-fill-color': 'var(--dove-gray)',
          },
          [`.MuiOutlinedInput-input`]: {
            '-webkit-text-fill-color': 'var(--tundora)',
          },
        },
      },
    },
  },
})

const LoggedUserLayout = () => {
  const { user } = useAuthContext()
  const { getItem, setItem } = useLocalStorage('cl_nav_menu')
  const [navMenuOpen, setNavMenuOpen] = useState<boolean>(getItem() ?? true)
  const [storeNavMenuOpen, setStoreNavMenuOpen] = useState<boolean>(
    getItem() ?? true
  )

  const navWidth = user.companyOptions.includes('MENU_JOBS_STATUS')
    ? 280
    : navMenuOpen
      ? 265
      : 55

  // Update localstorage item on change
  useEffect(() => {
    setItem(storeNavMenuOpen)
  }, [setItem, storeNavMenuOpen])

  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <NotificationsCounterContextProvider>
          <SupportCounterContextProvider>
            <VersionChecker />
            <Box
              sx={{
                display: 'flex',
                flexFlow: 'column',
                height: '100vh',
              }}
            >
              <Box
                sx={{
                  display: 'grid',
                  flex: '1 0 auto',
                  gridTemplateColumns: `${
                    navMenuOpen
                      ? navWidth + 'px calc(100% - ' + navWidth + 'px)'
                      : navWidth + 'px calc(100% - ' + navWidth + 'px)'
                  }`,
                  transition: 'grid var(--global-transition-timing)',
                }}
              >
                <LeftMenu
                  navMenuOpen={navMenuOpen}
                  setNavMenuOpen={setNavMenuOpen}
                  storeNavMenuOpen={storeNavMenuOpen}
                  setStoreNavMenuOpen={setStoreNavMenuOpen}
                />
                <Content />
              </Box>
            </Box>

            <SupportButton navWidth={navWidth} />
          </SupportCounterContextProvider>
        </NotificationsCounterContextProvider>
      </div>
    </ThemeProvider>
  )
}

export default LoggedUserLayout
